import { createContext } from 'react'

export interface DocumentURLContextType {
  show: (id: number | string) => string
}

function defaultValue(_id: number | string): string {
  throw new Error('Using DocumentURLContext.Consumer without Provider in the component chain')
}

export default createContext<DocumentURLContextType>({
  show: defaultValue,
})
